const key = (s) => (s || "").trim().toLowerCase();
export const fmt = (v, cur) => `${cur ? `${cur} ` : ""}${Math.round(v).toLocaleString()}`;

export const split = (spending, tax) => {
  const rows = (spending || []).filter((r) => r.amount);
  const sum = rows.reduce((a, r) => a + r.amount, 0) || 1;
  return rows.map((r) => ({ ...r, share: (tax * r.amount) / sum, pct: (r.amount / sum) * 100 }));
};

const Change = ({ from, to, cur }) => {
  if (from == null) return <span className="text-[11px] text-slate-400">new</span>;
  const d = to - from;
  return <span className={`${d > 0.5 ? "text-sky-700" : d < -0.5 ? "text-amber-700" : "text-slate-400"}`}>{d > 0 ? "+" : d < 0 ? "−" : ""}{fmt(Math.abs(d), cur)}</span>;
};

export const ShareTable = ({ rows, prev, cur, prevYear, year }) => {
  const old = Object.fromEntries((prev || []).map((r) => [key(r.category), r.share]));
  const c = prev ? "" : cur;
  return (
    <div className="mt-3 overflow-x-auto"><table className={`w-full ${prev ? "text-xs sm:text-sm" : "text-sm"}`} data-testid="budget-share-table">
      {prev && <thead><tr className="text-right text-[11px] uppercase tracking-wider text-slate-400"><th className="pb-1 text-left font-medium">{cur}</th><th className="pb-1 pl-2 font-medium">{prevYear}</th><th className="pb-1 pl-2 font-medium">{year}</th><th className="pb-1 pl-2 font-medium">Change</th></tr></thead>}
      <tbody>{rows.map((r, i) => (
        <tr key={`${r.category}-${i}`} className="border-t border-border" data-testid={`budget-share-row-${i}`}>
          <td className="py-1.5 pr-2"><span className="block">{r.category}</span><span className="mt-1 block h-1.5 rounded-full bg-slate-100"><span className="block h-1.5 rounded-full bg-[hsl(var(--facts))]" style={{ width: `${Math.min(100, r.pct)}%` }} /></span></td>
          {prev && <td className="whitespace-nowrap py-1.5 pl-2 text-right align-top text-slate-500" data-testid={`budget-share-row-${i}-prev`}>{old[key(r.category)] == null ? "—" : fmt(old[key(r.category)], c)}</td>}
          <td className="whitespace-nowrap py-1.5 pl-3 text-right align-top font-medium" data-testid={`budget-share-row-${i}-amount`}>{fmt(r.share, c)}</td>
          {prev && <td className="whitespace-nowrap py-1.5 pl-2 text-right align-top" data-testid={`budget-share-row-${i}-change`}><Change from={old[key(r.category)]} to={r.share} cur={c} /></td>}
        </tr>))}</tbody></table></div>
  );
};
